<template>
    <div>
        <b-overlay :show="isBusy" rounded="sm" opacity="0.50 " variant="white">
            <div class="text-center" v-if="_props.system.name">
                <p>Vous allez effectuer une extraction <br> pour l'outil  :  {{_props.system.name}} - Code : {{_props.system.code}} </p>
            </div>
            <div class="text-center" v-if="_props.sensor.name">
                <p>Vous allez effectuer une extraction <br> pour le compteur  :  {{_props.sensor.name}} </p>
            </div>
            <div class="text-center" v-if="_props.adherent.lastname">
                <p>Vous allez effectuer une extraction <br> pour l'adhérent  :  {{_props.adherent.title}} {{_props.adherent.lastname}} {{_props.adherent.firstname}} - Code : {{_props.adherent.code}} </p>
            </div>
      <!--      <form @submit.prevent="ask_extraction">
                <div class="row">
                    <div class="">
                        <table id="profile" class="table table-lg table-borderless text-center font-weight-normal">
                            <tr>
                                <td class="align-middle m-auto">A partir du</td>
                                <td class="align-middle">
                                    <b-form-group  :state="validateState('start_date')" class=" m-auto">
                                        <b-form-input  v-model="selected_start_date" :state="validateState('start_date')" type="date" class="form-control pointer" required>
                                        </b-form-input>
                                    </b-form-group>
                                </td>
                                
                                <td class="align-middle text-center">au</td>
                                <td class="align-middle">
                                    <b-form-group :state="validateState('end_date')" class=" m-auto"> 
                                        <b-form-input  v-model="selected_end_date" :state="validateState('end_date')" type="date" class="form-control pointer" required> 
                                        </b-form-input>
                                    </b-form-group>

                                </td>
                                <td class="align-middle">
                                    <b-form-group v-if="!_props.system.name" :state="validateState('system')" class=" m-auto">
                                        <b-form-select v-model="selected_by_id.system" :state="validateState('system')" v-if="selected_by == 'systems'" required
                                                class="custom-select form-control w-auto pointer">
                                            <b-form-select-option disabled value="null">Choisissez un outil</b-form-select-option>
                                            <b-form-select-option v-for="system in systems" v-bind:value="system.id" v-bind:key="system.id">
                                                    {{system.name}} - Code : {{system.code}}
                                            </b-form-select-option>
                                        </b-form-select> 
                                    </b-form-group> 
                                </td>
                                <td  v-if="!_props.system.name" class="align-middle">
                                    <b-button type="submit" :disabled="hasErrors" :class="{disabled:hasErrors}" class="btn btn-primary text-center m-auto">
                                        Demande d'extraction
                                    </b-button>
                                </td>
                                <td v-if="_props.system.name" class="align-middle">
                                    <b-button type="submit" :disabled="hasErrors" :class="{disabled:hasErrors}" class="btn btn-primary text-center m-auto"> 
                                        Demande d'extraction 
                                    </b-button>
                                </td>
                                <td class="align-middle">
                                    <div v-on:click="resetValues()" class="btn btn-danger m-auto" :title="[_props.system.name ? 'Réinitialiser les dates' : 'Réinitialiser les valeurs']"> 
                                        <i class="ti-close"></i>
                                    </div>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </form> -->
            
      <form class="form-inline" @submit.prevent="ask_extraction">
            <b-row class="row m-1">
                <b-form-group :state="validateState('start_date')"> 
                 <span class="mr-3">A partir du </span>  
                    <b-form-input  v-model="selected_start_date" 
                            :state="validateState('start_date')"
                            type="date" class="form-control w-auto pointer" required :max="today">
                    </b-form-input>
                </b-form-group>

                <b-form-group :state="validateState('end_date')"> 
                    
                 <span class="mr-3  ml-4 text-center">au </span>  
                    <b-form-input  v-model="selected_end_date" 
                            :state="validateState('end_date')"
                            type="date" class="form-control w-auto pointer" required :max="today"> 
                    </b-form-input>
                </b-form-group>

                

                <div class="mr-3 ml-3"> </div> <!--  select extraction type  -->
                <b-form-group
                    v-if="!_props.subscriptionOK && !_props.adherent.lastname && !_props.system.name && !_props.sensor.name"
                    class=""> <!-- m-2 mr-3 mr-4 ml-4 -->
                    <b-form-select  id="selectedBy"
                        class= "custom-select form-control w-auto pointer"
                        v-model="selected_by"
                        style="background-color:#d4d4d4"
                        required>
                        <!-- selected_by_code  <b-form-select-option disabled value="">Choisissez un type d'extraction</b-form-select-option> -->
                        <b-form-select-option v-bind:value="'sensors'" v-bind:key="'sensors'">
                            {{ 'compteurs' }}
                        </b-form-select-option>
                    </b-form-select>
                </b-form-group> 

                <b-form-group
                    v-if="_props.subscriptionOK && !_props.adherent.lastname && !_props.system.name && !_props.sensor.name"
                    class=""> <!-- m-2 mr-3 mr-4 ml-4 -->
                    <b-form-select  id="selectedBy"
                        class="custom-select form-control w-auto pointer"
                        v-model="selected_by"
                        required>
                        <b-form-select-option disabled value="">Type d'extraction</b-form-select-option>
                        <b-form-select-option v-for="sBy in selectedBy" v-bind:value="sBy.name" v-bind:key="sBy.name">
                            {{ sBy.nom }}
                        </b-form-select-option>
                    </b-form-select>
                </b-form-group> 



                <div class="ml-3 mr-3" v-if="selected_by == 'adherents' && !_props.adherent.lastname && !_props.system.name && !_props.sensor.name"> </div>
                <b-form-group
                            v-if="!_props.adherent.lastname"
                            :state="validateState('adherent')"
                            class=""> <!-- m-2 mr-3 mr-4 ml-4 -->
                    <b-form-select 
                            v-model="selected_by_id.adherent"
                            :state="validateState('adherent')" 
                            v-if="selected_by == 'adherents'"
                            class="custom-select form-control w-auto pointer"
                            required>
                            <b-form-select-option disabled value="null">Choisir un adherent</b-form-select-option>
                            <b-form-select-option v-for="adherent in adherents" v-bind:value="adherent.id" v-bind:key="adherent.id">
                                {{adherent.title}} {{adherent.lastname}} {{adherent.firstname}}
                            </b-form-select-option>
                    </b-form-select> 
                </b-form-group> 

                <div class="ml-3 mr-3" v-if="selected_by == 'sensors' && !_props.adherent.lastname && !_props.system.name && !_props.sensor.name"> </div>
                <b-form-group
                            v-if="!_props.sensor.name" 
                            :state="validateState('sensor')" 
                            class=""> <!-- m-2 mr-3 mr-4 ml-4 -->
                    <b-form-select 
                            v-model="selected_by_id.sensor"
                            :state="validateState('sensor')" 
                            v-if="selected_by == 'sensors'"
                            class="custom-select form-control w-auto pointer"
                            required>
                            <b-form-select-option disabled value="null">Choisir un compteur</b-form-select-option>
                            <b-form-select-option v-for="sensor in sensors" v-bind:value="sensor.id" v-bind:key="sensor.id">
                                {{sensor.name}}
                            </b-form-select-option>
                    </b-form-select> 
                </b-form-group> 

                <div class="ml-3 mr-3" v-if="selected_by == 'systems' && !_props.adherent.lastname && !_props.system.name && !_props.sensor.name"> </div>
                <b-form-group
                            v-if="!_props.system.name" 
                            :state="validateState('system')" 
                            class=""> <!-- m-2 mr-3 mr-4 ml-4 -->
                    <b-form-select 
                            v-model="selected_by_id.system"
                            :state="validateState('system')" 
                            v-if="selected_by == 'systems'"
                            class="custom-select form-control w-auto pointer"
                            required>
                            <b-form-select-option disabled value="null">Choisir un outil</b-form-select-option>
                            <b-form-select-option v-for="system in systems" v-bind:value="system.id" v-bind:key="system.id">
                                {{system.name}} - Code : {{system.code}}
                            </b-form-select-option>
                    </b-form-select> 
                </b-form-group> 
                
                <div class="ml-3 mr-3" v-if="!_props.adherent.lastname && !_props.system.name && !_props.sensor.name"> </div>
                    <button 
                        type="submit" 
                        class="btn btn-primary text-center m-2 mr-4 w-auto" 
                        :disabled="hasErrors"
                        :class="{disabled:hasErrors}"> 
                        
                        Demande d'extraction 
                    </button>

                  <!--  <div v-on:click="resetValues()" class="btn btn-danger m-auto w-auto" :title="[_props.system.name ? 'Réinitialiser les dates' : 'Réinitialiser les valeurs']"> <i class="ti-close"></i></div>
              -->
                
            </b-row>  

       
        </form>
        <div class="text-center alert alert-danger " role="alert" v-if="error">
            Cette action nécessite un abonnement veuillez contactez KEMTAG !
            <i class="ti-close float-right mt-1" @click="error = false"></i>
        </div>
        <!-- for invalid feedback -->
        <b-alert class="text-center alert alert-warning" :show="validation['start_date'].before || validation['end_date'].after">{{invalidFeedback()}} </b-alert> 
        <!-- https://bootstrap-vue.org/docs/components/alert -->
        <div class="col-md-7 m-auto fixed-top mrg-top-60 text-center" v-if="alert.dismissCountDown">
        <b-alert 
                :show="alert.dismissCountDown"
                dismissible
                variant="success"
                @dismissed="alert.dismissCountDown=0"
                @dismiss-count-down="countDownChanged">
                <span class="text-center m-auto text-success">Votre demande d'extraction est enregistrée.
                <br> <hr> Cette alerte disparaîtra après {{alert.dismissCountDown}} secondes </span>
               <!-- <b-progress
                    variant="success"
                    :max="alert.dismissSecs"
                    :value="alert.dismissCountDown"
                    height="4px"></b-progress>
                -->
        </b-alert>
        </div>
        </b-overlay>
    </div>
</template>

<script>

	const date = /([12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))/;


    import api from "../../config/_api";
    import { mapGetters } from 'vuex';
    //import extractions from "../store/modules/extractions";
    //import {isSubscriptionValid} from '../../store/modules/auth';

    export default {
        name: "Extraction",
        data() {
            return {
                selectedBy:[
                    {name:"adherents", nom:"adhérents"},
                    {name:"sensors", nom:"compteurs"},
                    {name:"systems", nom:"outils"},
                    {name:"all_systems", nom:"tous les outils"},
                ],
                today : null,
                isBusy : false,
                api_url : api.url,
                selected_start_date: "",
                selected_end_date: "",
                selected_by: "",
                request_from_user: 1,
                error:false,              
                selected_by_id: {
                    sensor: null,
                    system: null,
                    adherent: null
                },
                validation : {
                        start_date : {
                            $dirty : true,
                            $error : false,
                            required : false,
                            date : false ,
                            before : false,
                        },
                        end_date : {
                            $dirty : true,
                            $error : false,
                            required : false,
                            date : false ,
                            after : false,

                        },
                        system :{
                            $error : true,
                            required : true,
                        },
                        sensor :{
                            $error : true,
                            required : true,
                        },
                        adherent :{
                            $error : true,
                            required : true,
                        }

                },
                alert : {
                        dismissSecs: 10,
                        dismissCountDown: 0,
                },
                setInterval : null,
            }
        },
        props: {
            subscriptionOK : {
                type : Boolean,
                required: true,
            },
            system: {
                type: Object,
                required: false,
                default: function () {
                    return { 
                        id: 1,
                        name: "",
                        code: "",
                    }
                }
            },
            sensor: {
                type: Object,
                required: false,
                default: function () {
                    return { 
                        id: 1,
                        name: "",
                    }
                }
            },
            adherent: {
                type: Object,
                required: false,
                default: function () {
                    return { 
                        id: 1,
                        lastname: "",
                        code: "",
                    }
                }
            },
            start_date : "",
        },
        computed: {
            ...mapGetters({
                systems: 'systems/systems',
                adherents: 'adherents/adherents',
                sensors: 'sensors/sensors',
                extractions: 'extractions/extractions',
                structure : 'structure/structure'
            }),
            hasErrors () {
                return this.validation['start_date'].$error 
					|| this.validation['end_date'].$error 
                    || ((this.validation['system'].$error && this.selected_by != 'all_systems')
                    && this.validation['sensor'].$error
                    && this.validation['adherent'].$error );
            },
        },

        mounted() {
            this.updateSelectedBySensor();
            this.$store.dispatch('extractions/getExtractions');
            this.$store.dispatch('sensors/getSensors');
            this.$store.dispatch('systems/getSystems');
            this.$store.dispatch('adherents/getAdherents');
            this.$store.dispatch('structure/getStructure');
            this.setDefaultDates();
            this.setSystemId();
            this.setSensorId();
            this.setAdherentId();
        },

        watch :{
            selected_start_date(){
                this.validation['start_date'].required = this.selected_start_date == '';
                this.validation['start_date'].date=date.exec(this.selected_start_date) == null;

                this.validation['start_date'].before = new Date(this.selected_start_date) >= new Date(this.selected_end_date);
				this.validation['end_date'].after = new Date(this.selected_end_date) <= new Date(this.selected_start_date);

                this.validation['start_date'].$error = this.validation['start_date'].required || this.validation['start_date'].before || this.validation['start_date'].date;
				this.validation['end_date'].$error = this.validation['end_date'].required || this.validation['end_date'].after || this.validation['end_date'].date;
            },
            selected_end_date(){
                this.validation['end_date'].required = this.selected_end_date == '';
                this.validation['end_date'].date=date.exec(this.selected_end_date) == null;

                this.validation['start_date'].before = new Date(this.selected_start_date) >= new Date(this.selected_end_date);
				this.validation['end_date'].after = new Date(this.selected_end_date) <= new Date(this.selected_start_date);

				this.validation['end_date'].$error = this.validation['end_date'].required || this.validation['end_date'].after || this.validation['end_date'].date;
                this.validation['start_date'].$error = this.validation['start_date'].required || this.validation['start_date'].before || this.validation['start_date'].date;
            },

            "selected_by_id.system"(){
                this.validation['system'].required = this.selected_by_id.system == null ;
                this.validation['system'].$error = this.validation['system'].required;
            },
            "selected_by_id.sensor"(){
                this.validation['sensor'].required = this.selected_by_id.sensor == null ;
                this.validation['sensor'].$error = this.validation['sensor'].required;
            },
            "selected_by_id.adherent"(){
                this.validation['adherent'].required = this.selected_by_id.adherent == null ;
                this.validation['adherent'].$error = this.validation['adherent'].required;
            },

        },

        methods: {
            updateSelectedBySensor(){
                if(!this.subscriptionOK){
                    this.selected_by = "sensors"
                }
            },
			validateState(name) {
				const { $dirty, $error } = this.validation[name];
				return $dirty ? !$error : null;
			},
            invalidFeedback(){
                if(this.validation['start_date'].before || this.validation['end_date'].after) {
					return 'La date de début doit être une date antérieure à la date de fin'
				} 
            },
            setDefaultDates(){
                let date= new Date();
                var dd = date.getDate(); 
                var mm = date.getMonth() + 1; 
                var yyyy = date.getFullYear(); 
                if (dd < 10) { 
                    dd = '0' + dd; 
                } 
                if (mm < 10) { 
                    mm = '0' + mm; 
                } 
                var today = yyyy + '-' + mm + '-' + dd;

                this.selected_end_date=today;
                this.today=today;

                if(this.start_date<this.today){
                    this.selected_start_date=this.start_date;
                }
                else{
                    this.start_date = new Date(this.start_date);
                    dd = this.start_date.getDate(); 
                    mm = this.start_date.getMonth() + 1; 
                    if (dd < 10) { 
                        dd = '0' + dd; 
                    } 
                    if (mm < 10) { 
                        mm = '0' + mm; 
                    } 
                    this.selected_start_date = yyyy-1 + '-' + mm + '-' + dd;
                }
            },
            resetValues(){
                this.setDefaultDates();
                if(!this.system.name){
                    this.selected_by_id.system=null;
                }
                if(!this.sensor.name){
                    this.selected_by_id.sensor=null;
                }
                if(!this.adherent.lastname){
                    this.selected_by_id.adherent=null;
                }
            },
            setSystemId(){
                if(this.system.name){
                    this.selected_by_id.system=this.system.id;
                    this.selected_by = "systems";
                }
            },
            setSensorId(){
                if(this.sensor.name){
                    this.selected_by_id.sensor=this.sensor.id;
                    this.selected_by = "sensors";
                }
            },
            setAdherentId(){
                if(this.adherent.lastname){
                    this.selected_by_id.adherent=this.adherent.id;
                    this.selected_by = "adherents";
                }
            },
            url_media(id) {
                return api.url + 'medias/download/' + id + '?structure_id=' + this.$store.getters.structure_id;
            },
            ask_extraction() {
                    this.isBusy=true;
              //  console.log(this.extractions);

                let data = {
                    selected_start_date: this.selected_start_date,
                    selected_end_date: this.selected_end_date,
                    selected_by: this.selected_by,
                    selected_by_id: 0,
                    selected_by_code : 0,
                    request_from_user: 1
                };

                if(this.selected_by == 'systems'){
                    if(this.system.name){
                        data.selected_by_code = this.system.id;
                    }
                    else{
                        data.selected_by_code = this.selected_by_id.system;
                    }
                }

                else if (this.selected_by == 'sensors'){
                    if(this.sensor.name){
                        data.selected_by_code = this.sensor.id;
                    }
                    else{
                        data.selected_by_code = this.selected_by_id.sensor;
                    }
                }

                else if (this.selected_by == 'adherents'){
                    if(this.adherent.lastname){
                        data.selected_by_code = this.adherent.id;
                    }
                    else{
                        data.selected_by_code = this.selected_by_id.adherent;
                    }
                }
                else if (this.selected_by == 'all_systems'){
                    data.selected_by_code = 0;
                    let start_date = new Date();
                    let end_date = new Date();
                    start_date =  Date.parse(this.selected_start_date);
                    end_date = Date.parse(this.selected_end_date);
                    if ((end_date - start_date) > (31*86400000))
                        {
                            this.isBusy=false;
                            this.validation['start_date'].$error = true;
                            return;
                        }

                }

                var selected_by_id = 0; 

                if(this.selected_by == "systems") {
                    selected_by_id = this.selected_by_id.system;
                }
                else if(this.selected_by == "sensors") {
                    selected_by_id = this.selected_by_id.sensor;
                }
                else if(this.selected_by == "adherents") {
                    selected_by_id = this.selected_by_id.adherent;
                }
                else if (this.selected_by == 'all_systems'){
                    data.selected_by_id = 0;
                }

                data.selected_by_id = selected_by_id;
                
                this.request_from_user = this.$store.getters.getProfile.id
 
                data.request_from_user = this.request_from_user;


                let date= new Date();
                let nowDate = Date.parse(date); // date actuel en timestamp                
                this.axios({url: api.url + 'structures?id=' + this.$store.getters.structure_id+ '&token='+this.$store.getters.getProfile.api_token, method: 'GET' })
                    .then(resp=>{

                        let endingDate = Date.parse(resp.data[0].contract_ending_date); // date de fin d'abonnement en timestamp                        
                        if ( endingDate >= nowDate && nowDate !== null) 
                        {
                            this.axios({url: api.url + 'extractions?structure_id=' + this.$store.getters.structure_id, data: data, method: 'POST' })
                            .then(resp => {                                
                                //this.$router.push("/extractions/getExtractions");
                                //this.$router.push("/extraction");
                                if(resp.status <400){
                                    this.showAlert();
                                    if((!this.system.name && this.selected_by == "systems") || (!this.sensor.name && this.selected_by == "sensors") || (!this.adherent.lastname && this.selected_by == "adherents")){
                                        this.resetValues();
                                        
                                        this.$store.dispatch('extractions/getExtractions');

                                        if(this.setInterval==null)   {
                                            this.setInterval = setInterval(() => {
                                            this.$store.dispatch('extractions/getExtractions').then( () =>{ 
                                                var i =false;
                                                for(var extract of this.extractions){
                                                    if(extract['status']==1 || extract['status']==2){
                                                        i=true;
                                                        break;
                                                        }
                                                    }
                                                    if(i==false){
                                                        clearInterval(this.setInterval);
                                                        this.setInterval=null;
                                                    }
                                                } );
                                                }, 35000); 
                                            
                                            }
                                        }
                                }
                                
                                this.isBusy=false;
                            })
                           .catch(err => {
                               // console.log(err);
                                
                            this.isBusy=false;    
                            
                                        this.$store.dispatch('extractions/getExtractions');                             
                            });

                            }
                        else {                            
                            this.error = true; 
                            this.isBusy=false;                           
                        //    console.log("pas d'abonnement");                                                       
                        }  
                        
                                        this.$store.dispatch('extractions/getExtractions');  
                    })
                    .catch((err) => {
                                           
                            this.error = true; 
                            this.isBusy=false; 
                            
                                        this.$store.dispatch('extractions/getExtractions');
                    });


            },
            countDownChanged(dismissCountDown) {
                this.alert.dismissCountDown = dismissCountDown;
                if(this.alert.dismissCountDown==0){
                                        this.$emit('extraction-done');
                                    }
            },
            showAlert() {
                this.alert.dismissCountDown = this.alert.dismissSecs;
            },
        }
    }
    
</script>
<style>
    b-form-input{
            cursor: pointer;
}

</style>